import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-12 px-4 bg-surface text-center relative overflow-hidden shadow-lg shadow-black/40 border-y border-mint/10" data-id="element-50">
      <div className="absolute inset-0 opacity-[0.1] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-mint via-transparent to-transparent" data-id="element-51" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-52">
        <FadeIn data-id="element-53">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-mint mb-4 drop-shadow-[0_0_15px_rgba(74,222,128,0.3)]" data-id="element-54">
            SALUD EN TU PLATO™
          </h2>

          <p className="text-xl md:text-2xl text-dark/90 font-medium mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-55">
            Si hoy sentís que tu consulta depende demasiado de tu memoria, tu
            energía o tu improvisación, este sistema te ordena el trabajo y te
            devuelve claridad.
          </p>
        </FadeIn>
      </div>
    </section>;
}